exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-charts[data-v-eee04976]{padding:0.20833rem 0;display:flex;justify-content:center;gap:0.3125rem;flex-wrap:wrap}.m-charts .chartCt[data-v-eee04976]{flex-shrink:0;flex-grow:0;width:2.08333rem;height:2.08333rem}\n", ""]);

// exports
